import type { SVGProps } from 'react'

export function OneCircleFading(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 22 22'
      fill='none'
      {...props}
    >
      <path
        d='M11 1C12.9401 0.999647 14.8385 1.56368 16.4637 2.62336C18.0889 3.68303 19.3707 5.19259 20.153 6.96804C20.9352 8.74349 21.1841 10.7082 20.8693 12.6226C20.5545 14.537 19.6896 16.3185 18.38 17.75M1.5 7.875C1.18135 8.84366 1.01273 9.85536 1 10.875M1.83008 15C2.39158 16.2918 3.21966 17.4505 4.26008 18.4M3.63599 4.23493C3.91503 3.93116 4.2126 3.64495 4.52699 3.37793M7.64404 20.42C10.1377 21.3084 12.8819 21.1718 15.275 20.04M11.5 15V6C11 7 9.5 8.5 8 9'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
